import { render, staticRenderFns } from "./PHTabs.vue?vue&type=template&id=5634aa1e&scoped=true"
import script from "./PHTabs.vue?vue&type=script&lang=js"
export * from "./PHTabs.vue?vue&type=script&lang=js"
import style0 from "./PHTabs.vue?vue&type=style&index=0&id=5634aa1e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5634aa1e",
  null
  
)

export default component.exports